export const PanelMode = {
  Normal: "Normal",
  Fullscreen: "Fullscreen",
  Edit: "Edit"
};
export default PanelMode;
